<mat-tab-group [ngClass]="{ 'mat-mdc-tab-body-content-visible': true }">
  <mat-tab label="Dados pessoais">
    <ng-template mat-tab-label>
      <i class="pi pi-fw pi-book text-primary mr-1"></i>
      <span class="font-bold fs-normal">Dados</span>
    </ng-template>
    <p-divider align="left" class="width-100">
      <div class="inline-flex align-items-center">
        <i class="pi pi-fw pi-building text-primary mr-1"></i>
        <span class="font-bold fs-normal">Informações da empresa</span>
      </div>
    </p-divider>
    <div class="row">
      <mat-form-field class="col-md-3 mt-3" appearance="outline">
        <mat-label>CNPJ</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.cnpj | cpfCnpj"
        />
      </mat-form-field>
      <mat-form-field class="col-md-3 mt-3" appearance="outline">
        <mat-label>Data de abertura</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.dataAbertura | date: 'shortDate'"
        />
      </mat-form-field>
      <mat-form-field class="col-md-3 mt-3" appearance="outline">
        <mat-label>Nº CNAE principal</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.cnaePrincipal"
        />
      </mat-form-field>
      <mat-form-field class="col-md-3 mt-3" appearance="outline">
        <mat-label>Nº CNAE secundário</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.cnaeSecundario"
        />
      </mat-form-field>
      <mat-form-field class="mt-3 col-md-12" appearance="outline">
        <mat-label>Razão social</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.razaoSocial | uppercase"
        />
      </mat-form-field>
      <mat-form-field class="mt-3 col-md-12" appearance="outline">
        <mat-label>Nome fantasia</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.nomeFantasia | uppercase"
        />
      </mat-form-field>
      <mat-form-field class="mt-3 col-md-12" appearance="outline">
        <mat-label>CNAE principal</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.descricaoCnaePrincipal | uppercase"
        />
      </mat-form-field>
      <mat-form-field class="mt-3 col-md-12" appearance="outline">
        <mat-label>CNAE secundário</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.descricaoCnaeSecundario | uppercase"
        />
      </mat-form-field>
    </div>
    <p-divider align="left" class="width-100">
      <div class="inline-flex align-items-center">
        <i class="pi pi-fw pi-phone text-primary mr-1"></i>
        <span class="font-bold fs-normal">Contatos</span>
      </div>
    </p-divider>
    <div
      *ngIf="pessoaJuridica.contatos.length === 0"
      style="height: 200px;"
      class="flex justify-content-center align-items-center"
    >
      <div
        class="flex justify-content-center align-items-center flex-column"
        style="color: #999;"
      >
        <i class="mdi mdi-phone-off-outline icon-format-empty-list"></i>
        <p style="font-size: 16px; text-align: center;">
          Nenhum contato cadastrado
        </p>
      </div>
    </div>
    <mat-list
      class="row mt-3 justify-content-center"
      [ngClass]="{ 'mat-mdc-list-flex': true }"
      *ngIf="pessoaJuridica.contatos.length > 0"
    >
      <mat-list-item
        class="col-md-5 card mat-elevation-z5 cursor-pointer mr-2"
        pTooltip="Editar contato"
        *ngFor="let contato of pessoaJuridica.contatos; let i = index"
      >
        <div
          class="flex align-items-center justify-content-between width-100 p-2"
        >
          <div class="flex flex-column w-8rem">
            <div matLine class="font-light mb-2">
              <i
                matListIcon
                class="pi pi-fw pi-address-book text-primary fs-small"
              ></i>
              <span matLine class="fs-normal ml-2">
                {{
                  contato.contato.length > 15
                    ? contato.contato.substring(0, 15) + '...'
                    : contato.contato
                }}
              </span>
            </div>
            <span class="font-bold" matLine>
              {{
                formatarTags(
                  contato.tag.length > 15
                    ? contato.tag.substring(0, 15)
                    : contato.tag
                )
              }}
            </span>
          </div>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-tab>
  <mat-tab label="Endereços">
    <ng-template mat-tab-label>
      <i class="pi pi-fw pi-home text-primary mr-1"></i>
      <span class="font-bold fs-normal">Endereços</span>
    </ng-template>
    <div
      *ngIf="pessoaJuridica.enderecos.length === 0"
      style="height: 200px;"
      class="flex justify-content-center align-items-center"
    >
      <div
        class="flex justify-content-center align-items-center flex-column"
        style="color: #999;"
      >
        <i class="mdi mdi-map-check-outline icon-format-empty-list"></i>
        <p style="font-size: 16px; text-align: center;">
          Nenhum endereço registrado
        </p>
      </div>
    </div>
    <div class="row" *ngIf="pessoaJuridica.enderecos.length === 1">
      <mat-form-field class="col-md-3" appearance="outline">
        <mat-label>CEP</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.enderecos[0].cep | cep"
        />
      </mat-form-field>
      <mat-form-field class="col-md-9" appearance="outline">
        <mat-label>Múnicipio</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="
            pessoaJuridica.enderecos[0].cidade +
              '/' +
              pessoaJuridica.enderecos[0].uf | uppercase
          "
        />
      </mat-form-field>
      <mat-form-field class="mt-3 col-md-10" appearance="outline">
        <mat-label>Logradouro</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="
            pessoaJuridica.enderecos[0].tipoLogradouro +
              '. ' +
              pessoaJuridica.enderecos[0].logradouro | uppercase
          "
        />
      </mat-form-field>
      <mat-form-field class="mt-3 col-md-2" appearance="outline">
        <mat-label>Nº</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.enderecos[0].numero | uppercase"
        />
      </mat-form-field>
      <mat-form-field class="mt-3 col-md-6" appearance="outline">
        <mat-label>Complemento</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.enderecos[0].complemento | uppercase"
        />
      </mat-form-field>
      <mat-form-field class="mt-3 col-md-6" appearance="outline">
        <mat-label>Bairro</mat-label>
        <input
          type="text"
          readonly
          matInput
          [value]="pessoaJuridica.enderecos[0].bairro | uppercase"
        />
      </mat-form-field>
    </div>

    <div *ngIf="pessoaJuridica.enderecos.length > 1">
      <mat-tab-group [ngClass]="{ 'mat-mdc-tab-body-content-visible': true }">
        <mat-tab
          *ngFor="let endereco of pessoaJuridica.enderecos; let index = index"
          [label]="index + 1 + 'º endereço'"
        >
          <div class="row">
            <mat-form-field class="mt-3 col-md-3" appearance="outline">
              <mat-label>CEP</mat-label>
              <input
                type="text"
                readonly
                matInput
                [value]="endereco.cep | cep"
              />
            </mat-form-field>
            <mat-form-field class="mt-3 col-md-9" appearance="outline">
              <mat-label>Múnicipio</mat-label>
              <input
                type="text"
                readonly
                matInput
                [value]="endereco.cidade + '/' + endereco.uf | uppercase"
              />
            </mat-form-field>
            <mat-form-field class="mt-3 col-md-10" appearance="outline">
              <mat-label>Logradouro</mat-label>
              <input
                type="text"
                readonly
                matInput
                [value]="
                  endereco.tipoLogradouro + '. ' + endereco.logradouro
                    | uppercase
                "
              />
            </mat-form-field>
            <mat-form-field class="mt-3 col-md-2" appearance="outline">
              <mat-label>Nº</mat-label>
              <input
                type="text"
                readonly
                matInput
                [value]="endereco.numero | uppercase"
              />
            </mat-form-field>
            <mat-form-field class="mt-3 col-md-6" appearance="outline">
              <mat-label>Complemento</mat-label>
              <input
                type="text"
                readonly
                matInput
                [value]="endereco.complemento | uppercase"
              />
            </mat-form-field>
            <mat-form-field class="mt-3 col-md-6" appearance="outline">
              <mat-label>Bairro</mat-label>
              <input
                type="text"
                readonly
                matInput
                [value]="endereco.bairro | uppercase"
              />
            </mat-form-field>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-tab>
</mat-tab-group>
